import { useTranslation } from 'react-i18next'

import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { Text } from '@reveni-io/reveni-ui'

import ContentBlockItem from './ContentBlockItem/ContentBlockItem'
import useContentBlocks from './hooks/useContentBlocks'
import * as Styles from './styles'

const ContentBlocks = ({ blocks, onChangeBlocks, disabled }) => {
  const { t } = useTranslation()
  const sensors = useSensors(useSensor(PointerSensor))
  const { handleSortEnd, handleSortStart, handleToggle } = useContentBlocks({ blocks, onChangeBlocks })

  return (
    <Styles.Container>
      <Text type="titleS">{t('Bloques de contenido')}</Text>
      <Text type="bodyMRegular">
        {t('Elige qué bloques incluir en tu plantilla de correo. Arrástralos para ordenar cómo aparecerán.')}
      </Text>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleSortEnd}
        onDragStart={handleSortStart}
      >
        <SortableContext items={blocks.map(b => b.identifier)} strategy={verticalListSortingStrategy}>
          <Styles.BlocksContainer>
            {blocks.map(block => (
              <ContentBlockItem key={block.identifier} block={block} onToggle={handleToggle} disabled={disabled} />
            ))}
          </Styles.BlocksContainer>
        </SortableContext>
      </DndContext>
    </Styles.Container>
  )
}

export default ContentBlocks
